import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessPunchCardSequenceManagerHandler {
 	url: any;
 	token: any;
  	punchCardId: any = 0; 

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	getPunchCardSequences(punchCardId, cb){	
	  	this.url = this.globals.dataUrl + 'businessPunchCardSequence/punchCardId/' + punchCardId + "/v2";

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

  	getPunchCardSequence(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessPunchCardSequence/' + id + "/v2";

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

	createPunchCardSequence(params, cb){
	    this.url = this.globals.dataUrl + 'businessPunchCardSequence' + "/v2";

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response.Data);
		    });  
		})           
	}

	udpatePunchCardSequence(id, params, cb){
	    this.url = this.globals.dataUrl + 'businessPunchCardSequence/' + id + "/v2";

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response);
		    }); 
		});             
	}

	deletePunchCardSequence(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessPunchCardSequence/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.delete(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res);
		    });   
    	})
  	}

	punchUserCard(params){
	    this.url = this.globals.dataUrl + 'consumerPunchCard/redeem/punchCardId/' + params.PunchCardId;

	    console.log('punchusercard url: ' + this.url);
	    console.log('punchusercard params: ' + params.UserId);

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof params.cb == "function") params.cb(response);
		    });  
		})           
	}

	updatePunchCardSequenceImage(params){		
	  	this.url = this.globals.dataUrl + 'businessPunchCardSequence/image';

    	this.storage.get('loginData').then((loginData) => {
    		console.log("||Before post||");

		    this.http.post(
		        this.url,
		        {RewardImagePath: params.imageString,
		         Id: params.id}, 
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => {
		    	console.log("||Mapping||");
		    	console.log("||Status||");
		    	console.log(res.status);
			    // If request fails, throw an Error that will be caught
			    if(res.status < 200 || res.status >= 300) {
			      throw new Error('This request has failed ' + res.status);
			    } 
			    // If everything went fine, return the response
			    else {
			      return res.json();
			    }
			})
		    .subscribe(
				(res) => {
					console.log("Returned data:");
					console.log(res);					
					if(typeof params.cb == "function") params.cb(res);
				}, 
				(err) => {
					console.log("Returned error:");
					console.log(err);
				}
		    );   
    	})
  	}
}



// WEBPACK FOOTER //
// ./src/providers/business-punch-card-sequence-handler.ts